import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { ImagemLogo } from '../api/dto/imagem-logo';


@Injectable({
    providedIn: 'root',
})
export class ImagemLogoService {
    constructor(private http: HttpClient) { }
    private url: string = UrlServidor.URL_BASE + 'imagens-logo';

    buscarPorId(id: number): Observable<ImagemLogo> {
        return this.http.get<ImagemLogo>(this.url + '/' + id);
    }

    salvar(imagemLogo?: ImagemLogo): Observable<ImagemLogo> {
        return this.http.post<ImagemLogo>(this.url, imagemLogo);
    }
}